import { render, staticRenderFns } from "./_receives.vue?vue&type=template&id=ae28eedc&scoped=true&"
import script from "./_receives.vue?vue&type=script&lang=js&"
export * from "./_receives.vue?vue&type=script&lang=js&"
import style0 from "./_receives.vue?vue&type=style&index=0&id=ae28eedc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae28eedc",
  null
  
)

export default component.exports